module.exports = __webpack_public_path__ + "img/isPro1_4.599a7db1.png";